import React from "react";
import { SVG, IconProps } from "../SVG";
export const HBA = ({ color = "#13126C", strokeWidth = 2, ...props }: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
        <path
            stroke={color}
            strokeLinejoin="round"
            strokeWidth={1.75}
            d="M13.795 7h-3.59v3.205H7v3.59h3.205V17h3.59v-3.205H17v-3.59h-3.205V7Z"
        />
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="M21 4H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z"
        />
    </SVG>
);
HBA.displayName = "HBA";
